import { QueryClientProvider } from "@tanstack/react-query";
import { type ComponentPropsWithoutRef, Suspense, lazy } from "react";
import { queryClient } from "../../query";

const SupportFormComponent = lazy(() => import("./component"));

export default function SupportForm(
  props: ComponentPropsWithoutRef<typeof SupportFormComponent>
) {
  return (
    <QueryClientProvider client={queryClient}>
      <Suspense>
        <SupportFormComponent {...props} />
      </Suspense>
    </QueryClientProvider>
  );
}
